import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { FC, useEffect, useRef, useState } from "react";
import classes from "../index.module.css";
import { useOperatorAssignmentContext } from "../ContextProvider";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select, { SelectChangeEvent } from "@material-ui/core/Select";
import {
  mdiCogRefreshOutline,
  mdiCheck,
  mdiWindowClose,
  mdiMagnify as mdiSelectSearch,
} from "@mdi/js";
import Icon from "@mdi/react";
import "./filters.css";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import { Checkbox, Chip, Input, ListItemText } from "@material-ui/core";
import handleNotification from "../../../utils/handleNotification";

const ORDERS_COUNT = [1, 3, 5, 7, 10, 15, 20];
const SELECTIVE_DATE_VALUE = "SELECTIVE";

const Filters: FC = () => {
  const [dateFilter, setDateFilter] = useState<[]>([]);
  const [typeFilter, setTypeFilter] = useState<[]>([]);
  const [partner, setPartner] = useState<[]>([]);
  const [count, setCount] = useState<number>(5);
  const [formIsActive, setFormIsActive] = useState<boolean>(false);
  const [customDateFrom, setCustomDateFrom] = useState<object>(new Date());
  const [customDateTo, setCustomDateTo] = useState<object>(new Date());
  const [searchPartner, setSearchPartner] = useState<string>("");
  const [activeSearchPartner, setActiveSearchPartner] =
    useState<boolean>(false);

  const searchPartnerRef = useRef();

  const {
    orderTypes,
    dateTypes,
    partners,
    saveFilter,
    status,
    getStatisticByOrderType,
  } = useOperatorAssignmentContext();

  function initiateStatesByStatus(status = {}) {
    status.orderTypes && setDateFilter(status.dateTypes?.map((el) => el.name));
    status.orderTypes && setTypeFilter(status.orderTypes?.map((el) => el.name));
    status.partners && setPartner(status.partners?.map((el) => el.id));
    status.assignmentCount && setCount(status.assignmentCount);
    status.customDateFrom && setCustomDateFrom(status.customDateFrom);
    status.customDateTo && setCustomDateTo(status.customDateTo);
  }

  useEffect(() => {
    initiateStatesByStatus(status);
  }, [status]);

  function handleDateChange(_, newDate) {
    if (dateFilter.includes(SELECTIVE_DATE_VALUE)) {
      setDateFilter(newDate.filter((el) => el !== SELECTIVE_DATE_VALUE));
    } else if (newDate.includes(SELECTIVE_DATE_VALUE) && newDate.length > 1) {
      setDateFilter([SELECTIVE_DATE_VALUE]);
    } else {
      setDateFilter(newDate);
    }
  }

  function handleTypeChange(_, newType) {
    setTypeFilter(newType);
  }

  function handlePartnerChange(event: SelectChangeEvent) {
    setPartner(event.target.value.filter((el) => el));
  }

  function handleOrderCountChange(event: SelectChangeEvent) {
    setCount(event.target.value);
  }

  function save() {
    if (!dateFilter.length) {
      handleNotification("فیلد تاریخ نمی تواند خالی باشد.", "error");
    } else if (!orderTypes.length) {
      handleNotification("فیلد نوع سفارش نمی تواند خالی باشد.", "error");
    } else if (!partner.length) {
      handleNotification("فیلد شرکت نمی تواند خالی باشد.", "error");
    } else {
      saveFilter({
        assignmentCount: count,
        customDateFrom:
          typeof customDateFrom === "string"
            ? customDateFrom
            : customDateFrom?.toJSON()?.split("T")?.[0],
        customDateTo:
          typeof customDateTo === "string"
            ? customDateTo
            : customDateTo?.toJSON()?.split("T")?.[0],
        dateTypes: dateFilter,
        orderTypes: typeFilter,
        partners: partner,
      }).then(() => {
        setFormIsActive(false);
        getStatisticByOrderType();
      });
    }
  }

  function cancel() {
    initiateStatesByStatus(status);
    setFormIsActive(false);
  }

  function getPartnerLabelById(id) {
    return partners.find((p) => p.id === id)?.name;
  }

  useEffect(() => {
    searchPartnerRef.current?.focus();
  }, [searchPartner]);

  function selectAllPartner(value) {
    setPartner(value ? partners.map((el) => el.id) : []);
  }

  return (
    <div
      className={`${classes.filters} ${formIsActive ? "" : classes.disabled}`}
    >
      <div className="fields">
        <div className={classes.label}>فیلتر کردن سفارش‌ها بر اساس:</div>
        <div className={classes.filter}>
          <div className={classes.label}>تاريخ پردازش:</div>
          <div className={classes.field}>
            <ToggleButtonGroup
              color="primary"
              value={dateFilter}
              onChange={handleDateChange}
              aria-label="Platform"
            >
              {dateTypes.map(({ id, name, title }) => (
                <ToggleButton key={id} value={name} disabled={!formIsActive}>
                  {title}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>
        </div>
        {dateFilter?.includes(SELECTIVE_DATE_VALUE) && (
          <div className={classes.filter}>
            <div className={classes.label}>تاریخ انتخابی:</div>
            <div className={classes.field}>
              <div className={classes.rowBetween}>
                <div>
                  <span>از</span>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      fullWidth
                      autoOk
                      variant="inline"
                      format="YYYY/MM/DD"
                      disabled={!formIsActive}
                      value={customDateFrom}
                      labelFunc={(date) =>
                        date?.isValid() ? date.format("jYYYY/jMM/jDD") : ""
                      }
                      onChange={(value) => {
                        if (value) {
                          value.add(5, "hours");
                          setCustomDateFrom(value.toDate());
                        }
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div>
                  <span>تا</span>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      fullWidth
                      autoOk
                      variant="inline"
                      format="YYYY/MM/DD"
                      disabled={!formIsActive}
                      value={customDateTo}
                      labelFunc={(date) =>
                        date?.isValid() ? date.format("jYYYY/jMM/jDD") : ""
                      }
                      onChange={(value) => {
                        if (value) {
                          value.add(5, "hours");
                          setCustomDateTo(value.toDate());
                        }
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={classes.filter}>
          <div className={classes.label}>نوع سفارش:</div>
          <div className={classes.field}>
            <ToggleButtonGroup
              color="primary"
              value={typeFilter}
              onChange={handleTypeChange}
              aria-label="Platform"
            >
              {orderTypes.map(({ id, name, title }) => (
                <ToggleButton key={id} value={name} disabled={!formIsActive}>
                  {title}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>
        </div>
        <div className={classes.filter}>
          <div className={classes.label}>شرکت:</div>
          <div className={classes.field}>
            <Select
              onClose={() => {
                setActiveSearchPartner(false);
                setSearchPartner("");
              }}
              value={partner}
              multiple
              onChange={handlePartnerChange}
              disabled={!formIsActive}
              className={classes.select}
              MenuProps={{
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
                transformOrigin: {
                  vertical: "bottom",
                  horizontal: "center",
                },
                getContentAnchorEl: null,
              }}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.length > 3 ? (
                    <Chip
                      label={`${
                        selected.length === partners.length
                          ? "همه شرکت‌ها"
                          : selected.length + ` شرکت انتخاب شده `
                      } `}
                    />
                  ) : (
                    selected.map((value) => (
                      <Chip key={value} label={getPartnerLabelById(value)} />
                    ))
                  )}
                </div>
              )}
            >
              <div className={"firstRow"}>
                <div
                  className={`searchBox ${activeSearchPartner ? "open" : ""}`}
                >
                  <div
                    onClick={() => setActiveSearchPartner((s) => !s)}
                    className="button"
                  >
                    <Icon path={mdiSelectSearch} size={1} />
                  </div>
                  {activeSearchPartner && (
                    <>
                      <div className={"searchField"}>
                        <Input
                          value={searchPartner}
                          inputRef={searchPartnerRef}
                          onChange={(e) => setSearchPartner(e.target.value)}
                          autoFocus
                        />
                      </div>
                      <span
                        className={"button"}
                        onClick={() => {
                          setSearchPartner("");
                        }}
                      >
                        <Icon
                          path={mdiWindowClose}
                          size={1}
                          style={{ color: "#FF6B62" }}
                        />
                      </span>
                    </>
                  )}
                </div>
                <MenuItem>
                  <Checkbox
                    defaultChecked={partner.length === partners.length}
                    onChange={(_, value) => selectAllPartner(value)}
                  />
                  {!activeSearchPartner && (
                    <ListItemText primary={"انتخاب همه"} />
                  )}
                </MenuItem>
              </div>
              {partners
                .filter((el) => el.name.includes(searchPartner))
                .map((el, index) => (
                  <MenuItem key={el.id} value={el.id}>
                    <Checkbox checked={partner.includes(el.id)} />
                    <ListItemText primary={`${index + 1}. ${el.name}`} />
                  </MenuItem>
                ))}
            </Select>
          </div>
        </div>
        <div className={classes.filter}>
          <div className={classes.label}>تعداد سفارش در هر تخصیص:</div>
          <div className={classes.field}>
            <Select
              value={count}
              onChange={handleOrderCountChange}
              disabled={!formIsActive}
              className={classes.select}
            >
              {ORDERS_COUNT.map((el) => (
                <MenuItem key={el} value={el}>
                  {el}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </div>
      <div className={classes.actions}>
        {!formIsActive ? (
          <div className="blue-button">
            <Button
              onClick={() => setFormIsActive((state) => !state)}
              variant="contained"
              className={classes.blue}
              endIcon={<Icon path={mdiCogRefreshOutline} size={1} />}
            >
              ویرایش تنظیمات
            </Button>
          </div>
        ) : (
          <div className={classes.rowBetween}>
            <div className="red-button">
              <Button
                variant="contained"
                className={classes.redButton}
                endIcon={<Icon path={mdiWindowClose} size={1} />}
                onClick={cancel}
              >
                انصراف
              </Button>
            </div>
            <div className="green-button">
              <Button
                onClick={save}
                variant="contained"
                className={classes.greenButton}
                endIcon={<Icon path={mdiCheck} size={1} />}
              >
                اعمال تغییرات
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filters;
